import React from "react";
import { checkMobileNumberExistsOrNot, fetchUserBasicDetail, saveLoanId, SaveCreditjarBusinessDetailsByData } from "../../../AdminActionCreator.component";
import { _formatDate, basicFormValidation } from "../../../../../../utils/validation";
import PopUp from "../../../../../presentationals/Popup/Popup.component";



class PersonalEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            popupState: false,
            popupStatus: '',
            businessDetails: {
                name: "",
                referenceType: "",
                residenceValue: "",
                productsMachineryStock: "",
                noOfWorkers: "",
                noOfWorkingDays: "",
                visitingCardAvailable: "",
                gstNumber: "",
                address: "",
                pincode: "",
                state: "",
                city: "",
            }

        }
    }


    componentDidMount() {
        const { userdata } = this.props
        console.log("use", userdata)
        let userDetail = Object.assign({}, this.state.businessDetails)


        userDetail.name = userdata?.businessName ?? "",
            userDetail.referenceType = userdata?.tradeReference?.referenceType ?? "",
            userDetail.residenceValue = userdata?.businessAddress?.residenceValue ?? "",
            userDetail.productsMachineryStock = userdata?.productsMachineryStock ?? "",
            userDetail.noOfWorkers = userdata?.noOfWorkers ?? "",
            userDetail.noOfWorkingDays = userdata?.noOfWorkingDays ?? "",
            userDetail.visitingCardAvailable = userdata?.visitingCardAvailable ?? "",
            userDetail.gstNumber = userdata?.gstNumber ?? "",
            userDetail.address = userdata?.businessAddress?.address ?? "",
            userDetail.pincode = userdata?.businessAddress?.pincode ?? "",
            userDetail.state = userdata?.businessAddress?.state ?? "",
            userDetail.city = userdata?.businessAddress?.city ?? "",

            this.setState({ businessDetails: userDetail })
    }
    onSubmitHandler() {
        const { admin, userdata } = this.props;

        const obj = {
            userId: userdata?.userId ?? "",
            businessName: this.state.businessDetails.name ?? "",
            gstNumber: this.state.businessDetails.gstNumber ?? "",
            "businessAddress": {
                "address": this.state.businessDetails?.address ?? "",
                "city": this.state.businessDetails?.city ?? "",
                "state": this.state.businessDetails?.state ?? "",
                "pincode": this.state.businessDetails?.pincode ?? "",
                "residenceValue": this.state.businessDetails?.residenceValue ?? "",
            },
            "tradeReference": {
                "referenceType": this.state.businessDetails?.referenceType ?? ""
            },
            productsMachineryStock: this.state.businessDetails?.productsMachineryStock,
            "noOfWorkers": this.state.businessDetails?.noOfWorkers,
            "noOfWorkingDays": this.state.businessDetails?.noOfWorkingDays,
            "visitingCardAvailable": this.state.businessDetails?.visitingCardAvailable,
            totalSalaryWorkers: 0
        }



        SaveCreditjarBusinessDetailsByData(
            obj,
            callBack => {
                this.setState({
                    popupState: true,
                    popupStatus: 'Business Details Changed Successfully',
                    // dataChange:'yes'
                })

                this.removePopup()
            }
        )

    }
    removePopup() {
        setTimeout(
            function () {
                this.setState({ popupState: false })
            }.bind(this),
            5000
        )
    }
    closePopup() {
        this.setState({ popupState: false })
    }
    onChangeHandler(e, type) {

        let userDetail = Object.assign({}, this.state.businessDetails)
        userDetail[type] = e.target.value

        this.setState({ businessDetails: userDetail })

    }

    render() {
        const { admin, userdata } = this.props

        return (
            <div className="container details-new">
                {this.state.popupState == true ? (
                    <PopUp
                        closePopup={this.closePopup.bind(this)}
                        popupStatus={this.state.popupStatus}
                    />
                ) : (
                    ''
                )}
                <div className="details-new background-blur" style={{ background: 'rgb(5 5 5 / 20%)', color: '#000' }}>
                    <div className="edit-box ">
                        <div className="text-right" style={{ color: 'red' }}><i onClick={() => this.props.editHandler('')} style={{ fontSize: '20px', cursor: 'pointer' }} className="fa fa-times"></i></div>

                        <h4><b>Edit Business Details</b></h4>

                        <div className="row" style={{ marginTop: '20px' }}>
                            <div className="col-sm-4 col-xs-12">
                                <label>Business Name</label>
                                <input type="text" className="form-control" value={this.state.businessDetails.name} onChange={(e) => this.onChangeHandler(e, "name")} />

                            </div>
                            <div className="col-sm-4 col-xs-12">
                                <label>Trade Reference</label>
                                <select className="form-control" value={this.state.businessDetails.referenceType} onChange={(e) => this.onChangeHandler(e, "referenceType")}>
                                    <option value="" disabled>Select Option</option>
                                    <option value="SELLER">SELLER</option>
                                    <option value="BUYER">BUYER</option>

                                </select>
                            </div>
                            <div className="col-sm-4 col-xs-12">
                                <label>Owned / Rented</label>
                                <select className="form-control" value={this.state.businessDetails.residenceValue} onChange={(e) => this.onChangeHandler(e, "residenceValue")}>
                                    <option value="" disabled>Select Option</option>
                                    <option value="OWNED">Owned</option>
                                    <option value="RENTED">Rented</option>

                                </select>
                            </div>

                        </div>
                        <div className="row" style={{ marginTop: '20px' }}>
                            <div className="col-sm-4 col-xs-12">
                                <label>No. of Stocks</label>
                                <input type="text" className="form-control" value={this.state.businessDetails.productsMachineryStock} onChange={(e) => this.onChangeHandler(e, "productsMachineryStock")} />

                            </div>
                            <div className="col-sm-4 col-xs-12">
                                <label>No. of Workers</label>
                                <input type="number" className="form-control" value={this.state.businessDetails.noOfWorkers} onChange={(e) => this.onChangeHandler(e, "noOfWorkers")} />

                            </div>
                            <div className="col-sm-4 col-xs-12">
                                <label>No. of Working Days</label>
                                <input type="number" className="form-control" value={this.state.businessDetails.noOfWorkingDays} onChange={(e) => this.onChangeHandler(e, "noOfWorkingDays")} />

                            </div>

                        </div>

                        <div className="row" style={{ marginTop: '20px' }}>
                            <div className="col-sm-4 col-xs-12">
                                <label>Visiting Card</label>
                                <select type="number" className="form-control" value={this.state.businessDetails.visitingCardAvailable} onChange={(e) => this.onChangeHandler(e, "visitingCardAvailable")} >
                                    <option value={""}>Select Option</option>
                                    <option value={true}>Yes</option>
                                    <option value={false}>No</option>
                                </select>

                            </div>
                            <div className="col-sm-4 col-xs-12">
                                <label>GST Number</label>
                                <input type="text" className="form-control" value={this.state.businessDetails.gstNumber} onChange={(e) => this.onChangeHandler(e, "gstNumber")} />

                            </div>
                            <div className="col-sm-4 col-xs-12">
                                <label>Address</label>
                                <input type="text" className="form-control" value={this.state.businessDetails.address} onChange={(e) => this.onChangeHandler(e, "address")} />

                            </div>


                        </div>
                        <div className="row" style={{ marginTop: '20px' }}>

                            <div className="col-sm-4 col-xs-12">
                                <label>Pincode</label>
                                <input type="number" className="form-control" value={this.state.businessDetails.pincode} onChange={(e) => this.onChangeHandler(e, "pincode")} />

                            </div>
                            <div className="col-sm-4 col-xs-12">
                                <label>State</label>
                                <input type="text" className="form-control" value={this.state.businessDetails.state} onChange={(e) => this.onChangeHandler(e, "state")} />

                            </div>
                            <div className="col-sm-4 col-xs-12">
                                <label>City</label>
                                <input type="text" className="form-control" value={this.state.businessDetails.city} onChange={(e) => this.onChangeHandler(e, "city")} />

                            </div>


                        </div>

                        <div className="row " style={{ marginTop: '20px' }}>
                            <div className="col-xs-12">
                                <button className="btn btn-primary" id="" disabled={admin.emailId !== 'SuperUser' ? (userdata.statusId === '101' || userdata.statusId === '102' || userdata.statusId === '103' || userdata.statusId === '105' || userdata.statusId === '113' || userdata.statusId === '117' || userdata.statusId === '110' || userdata.statusId === '109') ? false : true : false} onClick={(e) => this.onSubmitHandler(e)}>
                                    Update Business Details
                                </button>
                            </div>
                        </div>





                    </div>

                </div>
            </div >
        )
    }
}
export default PersonalEdit